import React from 'react';
import { FaFacebookF, FaUsers, FaHandsHelping } from 'react-icons/fa';
import { Heading, PageTitle } from '../../../components';
import { kolejWaskotorowaData } from '../../../constants';
import '../KolejWaskotorowa.css';

const KolejWaskotorowaTowarzystwo = () => {
    const { society, facebookUrl } = kolejWaskotorowaData;

    return (
        <>
            <PageTitle
                title='Kolej Wąskotorowa'
                page='Towarzystwo'
                heading={society.title}
                subTitle={society.subtitle}
            />

            <section className='kw-section kw-society'>
                <div className='kw-container'>
                    <Heading title={society.subtitle} subTitle={society.intro} sideHeading />

                    <div className='kw-society-grid'>
                        {society.blocks.map((block) => (
                            <article key={block.id} className='kw-info-card'>
                                <div className='kw-info-icon'>
                                    {block.id === 1 && <FaUsers />}
                                    {block.id === 2 && <FaHandsHelping />}
                                    {block.id === 3 && <FaFacebookF />}
                                </div>
                                <h3>{block.title}</h3>
                                <p>{block.text}</p>
                            </article>
                        ))}
                    </div>

                    <div className='kw-cta-box'>
                        <div>
                            <h3>Skontaktuj się przez Facebooka</h3>
                            <p>
                                To najpewniejsza droga, jeśli chcesz dopytać o działania towarzystwa albo przesłać materiały archiwalne.
                            </p>
                        </div>

                        <a className='kw-button' href={facebookUrl} target='_blank' rel='noreferrer'>
                            <FaFacebookF />
                            Otwórz Facebook
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default KolejWaskotorowaTowarzystwo;